export default __webpack_public_path__ + "static/media/manual2.16a59748.docx";